
<template>
  <div class="container-fluid p-0 m-0">
    <div class="card-group-control card-group-control-right" v-bind:id="'accordion-control' + getId()">
      <div class="card border-0 p-0 m-0" style="background-color:none !important">
        <div class="card-header p-0 m-0 px-2" v-bind:class="{'active':expanded == true}">
          <h6 class="card-title" style="height: 39px; padding-top: 7px;">
            <a class="text-default" v-bind:class="{ collapsed: expanded == true }" v-bind:aria-expanded="show" v-bind:href="'#targetaccordion-control' + getId() + '-group1'" @click="toggle">{{title}}</a>
          </h6>
          <span v-bind:id="'targetaccordion-control' + getId() + '-group1'"></span>
        </div>

        <div v-bind:id="'accordion-control' + getId() + '-group1'" v-bind:class="{ 'show animated fadeIn': expanded == true }" class="collapse" v-bind:data-parent="'#accordion-control' + getId()">
          <div class="container-fluid skin light-bg">
            <div class="row">
              <div class="col">
                <slot></slot>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
  export default {
    name: 'container-expand-left',
    components: {
    },
    data() {
      return {
        expanded:false
      };
    },
    props: {
      title: {
        required: false,
        type: String,
        default: null
      },
      show: {
        required: false,
        type: String,
        default: 'false'
      }
    },
    methods: {
      toggle() {
        this.expanded = !this.expanded;
        //this.$forceUpdate()
        if (this.expanded == true)
          this.$emit("expanded");

        //var thisContext = this;

        //setTimeout(function () {
        //  thisContext.$forceUpdate()
        //}, 200)


        
      },
      getId() {
        return this._uid;
      }
    },
    
    created() {
    },
    mounted() {
      if (this.show == true)
        this.toggle()
      //this.expanded = this.show == 'true';
    }
  }
</script>


<style scoped>
  .card-header{
      background-color:transparent;
  }
  @media (max-width: 768px) {
  }
  .card {
    background-color:initial;
  }
  a {
    color:inherit !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/containers/large-container-expand-right.vue